import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import SectionTitle from '../layout/SectionTitle';
import { FaHandshake, FaUsers, FaAward, FaLightbulb, FaSmile } from 'react-icons/fa';

const Valeurs = () => {
  const { t } = useTranslation();
  
  // Données des valeurs
  const valuesData = [
    { 
      name: t('about.values.engagement.title'), 
      color: 'bg-white', 
      textColor: 'text-socabeg-blue',
      icon: <FaHandshake className="w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14 text-socabeg-blue" />
    },
    { 
      name: t('about.values.sharing.title'), 
      color: 'bg-socabeg-blue', 
      textColor: 'text-white',
      icon: <FaUsers className="w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14 text-white" />
    },
    { 
      name: t('about.values.quality.title'), 
      color: 'bg-socabeg-blue', 
      textColor: 'text-white',
      icon: <FaAward className="w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14 text-white" />
    },
    { 
      name: t('about.values.solution.title'), 
      color: 'bg-white', 
      textColor: 'text-socabeg-blue',
      icon: <FaLightbulb className="w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14 text-socabeg-blue" />
    },
    { 
      name: '', 
      color: '', 
      textColor: 'text-black', 
      icon: null 
    }, // Case vide à gauche
    { 
      name: t('about.values.caring.title'), 
      color: 'bg-socabeg-blue', 
      textColor: 'text-white',
      icon: <FaSmile className="w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14 text-white" /> 
    } // BIENVEILLANCE à droite
  ];
  
  return (
    <section className="py-8 bg-gray-50">
      <div className="container mx-auto px-4">
        <SectionTitle 
          overline={t('about.values.title')}
          highlight=""
          separatorColor="socabeg-blue"
          showLogo={true}
        />
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            <h2 className="text-3xl md:text-4xl font-bold mb-6">
              {t('about.values.mainTitle')}
            </h2>
            
            <p className="text-justify mb-4">
              {t('about.values.description1')}
            </p>
            <p className="text-justify mb-4">
              {t('about.values.description2')}
            </p>
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            viewport={{ once: true }}
            className="grid grid-cols-2 gap-0.5"
          >
            {valuesData.map((value, index) => {
              // Ne pas afficher de contenu si le nom est vide
              return (
                <div 
                  key={index} 
                  className={`${value.color} p-4 sm:p-6 md:p-8 flex flex-col items-center justify-center min-h-[150px]`}
                >
                  {value.name && (
                    <>
                      <h3 className={`text-base sm:text-lg md:text-xl font-bold mb-2 sm:mb-3 text-center break-words hyphens-auto ${value.textColor}`}>
                        {value.name}
                      </h3>
                      {value.icon && value.icon}
                    </>
                  )}
                </div>
              );
            })}

          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Valeurs;
